import { render, staticRenderFns } from "./class-discussion.vue?vue&type=template&id=33b9f840"
import script from "./class-discussion.vue?vue&type=script&lang=js"
export * from "./class-discussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports